// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"f1214044","239":"4b7346ef","453":"dfc249fc","455":"73a70019","977":"4cd5c95b"}[chunkId] + ".chunk.js";
};